<template>
    <div v-if="chips.length || total !== null || $slots.tools" class="d-flex flex-wrap align-center mt-2">
        <v-chip v-for="chip in chips" :key="chip.key" small outlined color="primary" class="mr-2 mb-1"
            close close-icon="fas fa-times" @click:close="$emit('remove', chip.key)">
            <v-icon v-if="chip.icon" left x-small>{{ chip.icon }}</v-icon>{{ chip.label }}
        </v-chip>
        <v-btn v-if="chips.length > 1" x-small text color="primary" class="mb-1 mr-2" @click="$emit('clear')">
            Limpiar
        </v-btn>
        <!-- con herramientas, contador y herramientas se alinean a la derecha -->
        <v-spacer v-if="$slots.tools"></v-spacer>
        <span v-if="total !== null" class="text-caption text--secondary mb-1">
            {{ totalText }}
        </span>
        <span v-if="$slots.tools" class="d-flex align-center ml-2"><slot name="tools"></slot></span>
    </div>
</template>
<script>
/**
 * Filtros activos como chips que se quitan de uno en uno.
 *
 * No sabe nada de filtros: la vista le pasa la lista ya armada y escucha
 * qué chip se quitó.
 *
 *   <FilterChips :chips="[{ key: 'provider', label: 'Proveedor: X', icon: 'fas fa-truck' }]"
 *                :total="totalItems" @remove="quitar" @clear="limpiar" />
 *
 * `total` es opcional: si es null no se muestra el contador.
 *
 * Slot `tools`: herramientas de la tabla (actualizar, exportar, columnas). Va a
 * la derecha de la fila, junto al contador, porque actúan sobre la tabla.
 */
export default {
    name: 'FilterChips',
    props: {
        chips: { type: Array, default: () => [] },
        total: { type: Number, default: null }
    },
    computed: {
        totalText() {
            const unit = this.total === 1 ? 'resultado' : 'resultados';
            return `${this.total.toLocaleString('es-MX')} ${unit}`;
        }
    }
}
</script>
